function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M2387.863-10796.148h9v9",
  "data-name": "Path 404",
  style: {
    fill: "none",
    stroke: "#555"
  },
  transform: "translate(-2387.863 10797.148)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 7.745 7.897 0",
  "data-name": "Line 19",
  style: {
    fill: "none",
    stroke: "#555"
  },
  transform: "translate(.637 1.5)"
}));
export default SvgIconGoto;